export default __webpack_public_path__ + "static/apple-touch-icon-9ab97603907d8ee1d165874c716881b6.png";